<div class="select-container" [class.open]="isOpen">

  <div class="select-trigger" (click)="toggle()">
    @if (!selectedValue) {
      <span class="placeholder">{{ placeholder }}</span>
    }
    @if (selectedValue) {
      <span class="selected-text">{{ selectedLabel }}</span>
    }

    <div class="actions">
      @if (selectedValue) {
        <hugeicons-icon [icon]="closeIcon" [size]="16" color="currentColor" class="clear-btn" (click)="clearSelection($event)"></hugeicons-icon>
      }
    </div>
  </div>

  @if (isOpen) {
    <div class="select-dropdown" [class.dropdown-top]="dropdownPosition === 'top'">
      @if (searchable) {
        <div class="search-box">
          <hugeicons-icon [icon]="searchIcon" [size]="18" color="currentColor"></hugeicons-icon>
          <input type="text" class="search-input" [(ngModel)]="searchValue" placeholder="Search..."
            (click)="$event.stopPropagation()">
        </div>
      }
      <div class="options-list">
        @for (option of filteredOptions; track option) {
          <div class="option-item"
            [class.selected]="option.value === selectedValue" (click)="selectOption(option)">
            <div class="option-content">
              <span class="label">{{ option.label }}</span>
              @if (option.subLabel) {
                <span class="sub-label">{{ option.subLabel }}</span>
              }
            </div>
            @if (option.value === selectedValue) {
              <hugeicons-icon [icon]="checkIcon" [size]="16" color="currentColor" class="check"></hugeicons-icon>
            }
          </div>
        }
        @if (filteredOptions.length === 0) {
          <div class="no-results">
            No results found
          </div>
        }
      </div>
    </div>
  }
</div>